import React, { SetStateAction } from 'react';
import { DeleteDialogMechanic, DeleteDialogParticipant } from 'entities/promo';
import { PromoDetailStateType } from 'entities/promo/types';

export const deletePromoDialog = (
  id: string,
  state: PromoDetailStateType,
  openDialog: boolean,
  setOpenDialog: React.Dispatch<SetStateAction<boolean>>,
) => {
  const { deleteVariant, deletedId } = state;

  switch (deleteVariant) {
    case 'deleteMechanic':
      return (
        <DeleteDialogMechanic
          promoId={id!}
          deleteId={deletedId}
          open={openDialog}
          setOpen={setOpenDialog}
        />
      );
    case 'deleteParticipant':
      return (
        <DeleteDialogParticipant
          promoId={id!}
          deleteId={state.deletedId}
          open={openDialog}
          setOpen={setOpenDialog}
        />
      );
    default:
      return null;
  }
};
